import { camelCase, isObject } from 'lodash-es';

export function camel<T>(obj): T {
  if (!isObject(obj)) {
    return null;
  }

  return Object.keys(obj).reduce((prevKeys: Object, currKey: string) => {
    const currentValue = obj[currKey];

    let newCamelCasedValue = currentValue;

    if (isObject(currentValue)) {
      newCamelCasedValue = camel(currentValue);
    } else if (Array.isArray(currentValue)) {
      newCamelCasedValue = currentValue.map(el => camel(el));
    }

    return { ...prevKeys, [camelCase(currKey)]: newCamelCasedValue };
  }, {}) as T;
}
